import 'firebase/firestore';
import firebase from 'firebase/app';
import config from '../config';

export const firebaseApp = firebase.initializeApp(config.firebaseConfig);
export const firestoreDb = firebase.firestore();

firebase
  .firestore()
  .enablePersistence({ synchronizeTabs: true })
  .catch(function(err) {
    if (err.code === 'failed-precondition') {
      // Multiple tabs open, persistence can only be enabled
      // in one tab at a a time.
      // ...
      console.log(
        'Multiple tabs open? Offline persistance can only be used by one tab at a a time.'
      );
    } else if (err.code === 'unimplemented') {
      console.log(
        'The current browser does not support the firestore persistance feature'
      );
      // The current browser does not support all of the
      // features required to enable persistence
      // ...
    }
  });
